import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import AOS from 'aos'
import 'aos/dist/aos.css'
import 'primeicons/primeicons.css'

Vue.config.productionTip = false
Vue.use(AOS.init())

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
